import React from 'react'
import {  Row, Typography, Col, List } from "antd";
import './Gift.css'
import { CheckOutlined } from '@ant-design/icons';

const { Title } = Typography;

export default function DiscountList(props) {
    const { onClick, discounts } = props

    const columns = [
        {
            title: 'کد',
            dataIndex: 'code',
            key: 'code',
            align: 'right',
        },
        {
            title: 'درصد تخفیف',
            dataIndex: 'discountPercentage',
            key: 'discountPercentage',
            align: 'right',
        },
        {
            title: 'سقف تخفیف',
            dataIndex: 'discountCeiling',
            key: 'discountCeiling',
            align: 'right',
        },
        {
            title: 'تعداد بار مانده',
            dataIndex: 'remainingUseNumber',
            key: 'remainingUseNumber',
            align: 'right',
        },

    ];

    return <React.Fragment>
        <Row className='px-40'>
            <Col span={24} className=''><Title className='f-22' level={4}>لیست تخفیف ها</Title></Col>
        </Row>
        <div className='px-40'>
            {
                (discounts && discounts.length) ?
                    <List
                        split={false}
                        className='mb-32'
                        size="small"
                        dataSource={discounts}
                        renderItem={item => <List.Item className="f-14 color-primary p-0 mb-1"><CheckOutlined
                            className='color-primary ml-1 f-18' />{item.code} | تخفیف {item.discountPercentage} ٪ تا سقف {item.discountCeiling} تومان تا {item.remainingUseNumber} بار دیگر</List.Item>}
                    />
                    // <Table pagination={false} style={{textAlign: 'right'}} columns={columns} dataSource={discounts}/>
                    :
                    <div className='text-center'>


                    </div>
            }
        </div>


    </React.Fragment>
}
